import { applyVariantPatches } from "functions/tlf/applyVariantPatches";
import { buildVariantPatch, VariantPatchResult } from "functions/tlf/buildVariantPatch";
import { getVariantPatchContext } from "./getVariantPatchContext";
import { TlfContextProps } from "./interface";

/**
 * Calculates the active patch by composing all other applied patches onto its baseline.
 *
 * @param state - Current TLF context state
 * @param context - Master and patch catalog state
 * @returns Active patch operations, or null when the patch cannot be calculated
 */
export const getActivePatchResult = (
  state: TlfContextProps,
  context: ReturnType<typeof getVariantPatchContext>,
): VariantPatchResult | null => {
  const { master, currentMaster, information } = context;
  const activeName = state.activeVariantPatchName;
  if (master === null || currentMaster === null || information === null || activeName === null)
    return null;
  const base = applyVariantPatches(
    master,
    information,
    state.appliedVariantPatches.filter((name) => name !== activeName),
  );
  // Applied patch selections are validated before an active patch is edited.
  // istanbul ignore next
  if (!base.success) return null;
  return buildVariantPatch(base.data, currentMaster);
};
